import { render, staticRenderFns } from "./todos.vue?vue&type=template&id=4d9fc63c&scoped=true&"
import script from "./todos.js?vue&type=script&lang=js&"
export * from "./todos.js?vue&type=script&lang=js&"
import style0 from "./todos.scss?vue&type=style&index=0&id=4d9fc63c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d9fc63c",
  null
  
)

export default component.exports